// src/redux/reducer.js
import { combineReducers } from "redux";
import { APPEND_PROJECTS, REMOVE_PROJECTS } from "./actionTypes";
import testCasesReducer from "./testCasesReducer";

// Projects reducer
const projectsInitialState = {
  projects: [],
};

const projectsReducer = (state = projectsInitialState, action) => {
  switch (action.type) {
    case APPEND_PROJECTS:
      return { ...state, projects: action.projects };
    case REMOVE_PROJECTS:
      return { ...state, projects: [] };
    default:
      return state;
  }
};

// Root reducer
const rootReducer = combineReducers({
  projects: projectsReducer,
  testCases: testCasesReducer,
});

export default rootReducer;
